export default __webpack_public_path__ + "static/media/marauders-map-v5.1-02-00.41462721.jpg";